import { API_ENDPOINT } from "../config/api";

export const getAbsoluteUrl = (relative_url: string): string => {
  return `${API_ENDPOINT}${relative_url}`;
};
